import {unref} from 'vue';
import {useCatalogVersionStore} from '~/store/rie/catalogVersion';
import type {Middleware} from 'openapi-fetch';

/**
 * The header name used to read and set the catalog version,
 * should match with what is expected in the backend.
 */
export const catalogVersionHttpHeader: Readonly<string> = 'X-Catalog-Version';

/**
 * Middleware to handle the catalog version in the request and response headers.
 * Catalog version is set from the backend in the response header.
 * The response header is used to set the version in the catalog Store.
 * If the catalog version in request headers does not match the one in active,
 * the backend is responsible for returning an error if needed.
 */
export const catalogVersionMiddleware = (): Middleware => ({
	onRequest: ({request}) => {
		const catalogVersionStore = useCatalogVersionStore();
		const catalogVersion = unref(catalogVersionStore.catalogVersion);
		if (catalogVersion) {
			request.headers.set(catalogVersionHttpHeader, catalogVersion);
		}
		return request;
	},
	onResponse: ({response}) => {
		const catalogVersionStore = useCatalogVersionStore();
		if (response.headers.has(catalogVersionHttpHeader)) {
			catalogVersionStore.catalogVersion = response.headers.get(catalogVersionHttpHeader);
		}
		return response;
	}
});
